const map = {
	"./cursed-places.jpg": 1722,
	"./demigods-heroes.jpg": 6226,
	"./festivals-rituals.jpg": 785,
	"./folk-tales.jpg": 7567,
	"./ghost-stories.jpg": 7072,
	"./gods-goddesses.jpg": 9178,
	"./mythological-creatures.jpg": 6622,
	"./nature-spirits.jpg": 9,
	"./sacred-places.jpg": 6044,
	"./tribal-legends.jpg": 6820,
	"./urban-legends.jpg": 4412,
	"./witches-sorcery.jpg": 540
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2260;